import React, { createContext, useContext, useState } from 'react';

export type OpenModalFn = (modal: (close: () => void) => React.ReactNode) => void;
const MockModalContext = createContext<{
  // eslint-disable-next-line func-call-spacing
  openModal: OpenModalFn;
}>({
  openModal: () => {},
});

export const MockModalProvider: React.FC<{
  children: ((openModal: OpenModalFn) => React.ReactNode) | React.ReactNode;
}> = ({ children }) => {
  const [modal, setModal] = useState<React.ComponentType | null>(null);

  const closeModal = () => setModal(null);
  const openModal = modalFn => setModal(modalFn(closeModal));

  return (
    <MockModalContext.Provider value={{ openModal }}>
      <>
        {modal}
        {typeof children === 'function' ? children(openModal) : children}
      </>
    </MockModalContext.Provider>
  );
};

export const useOpenMockModal = () => useContext(MockModalContext);
